import { useEffect, useRef } from 'react'
import type { RefObject } from 'react'

// 내 커서 위치(공동 편집 표시) — 고른 칸 + 그 칸에 입력 중인지.
// 입력 중은 그리드가 활성 칸에 dsg-active-cell-focus 를 붙이는 것으로 안다 (값을 고치는 동안만)
export function useLocate(wrapRef: RefObject<HTMLDivElement | null>, onLocate: ((key: string | null, field: string | null, editing: boolean) => void) | undefined) {
  const state = useRef({ key: null as string | null, field: null as string | null, editing: false })
  const onLocateRef = useRef(onLocate)
  useEffect(() => { onLocateRef.current = onLocate })

  const send = () => {
    const s = state.current
    onLocateRef.current?.(s.key, s.field, s.key != null && s.editing)
  }

  useEffect(() => {
    const wrap = wrapRef.current
    if (!wrap) return
    const check = () => {
      const editing = wrap.querySelector('.dsg-active-cell-focus') != null
      if (editing === state.current.editing) return
      state.current.editing = editing
      send()
    }
    const observer = new MutationObserver(check)
    observer.observe(wrap, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] })
    return () => observer.disconnect()
  }, [wrapRef])

  /** 그리드 onActiveCellChange 에서 */
  return (key: string | null, field: string | null) => {
    state.current.key = key
    state.current.field = field
    send()
  }
}
